<template>
  <v-container text-xs-center>
    <div class="elevation-5">
      <BaseToolbar toolbarTitle="Group's">
        <template v-slot:toolbarBtn>
          <!-- Search Input -->
          <v-text-field
            v-if="searchVisible"
            v-model="search"
            label="Search Group"
            single-line
            hide-details
            filled
            rounded
            dense
            style="margin-right: 8px; max-width: 130px"
          ></v-text-field>
          <!-- Expandable Search Icon -->
          <v-icon
            color="primary"
            @click="
              searchVisible = !searchVisible;
              search = '';
            "
            style="cursor: pointer"
          >
            search
          </v-icon>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <!-- Search Input -->
          <v-dialog
            v-model="dialogFilter"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                tune
              </v-icon>
              <!-- <span>{{ "Settings" }} </span> -->
            </template>

            <v-card>
              <!-- <v-card-title>
                <span class="headline">Athlete's Settings</span>
              </v-card-title> -->
              <v-card-text>
                <span class="headline">Group's Settings</span>

                <!-- Add Event Selection -->
                <v-flex xs12>
                  <EventCatalogSelect
                    v-model="selectedEvent"
                    :multiple="true"
                  />
                </v-flex>

                <v-divider style="margin: 8px"></v-divider>
                <v-select
                  v-model="competitiveFilter"
                  :items="filterOptions"
                  label="Filter by Group Type"
                  class="mt-1"
                  outlined
                  hide-details
                  @change="filterGroupData"
                />
                <v-divider style="margin: 12px"></v-divider>
                <v-select
                  v-model="status_selected"
                  :items="statusOptions"
                  v-if="isAdmin()"
                  :menu-props="{ maxHeight: '400' }"
                  label="Status"
                  multiple
                  dark
                  outlined
                  dense
                  hide-details
                  clearable
                  class="light-blue darken-4 select_tab_bar"
                >
                  >
                  <template v-slot:prepend-item>
                    <v-list-item-group>
                      <v-list-item @click="selectAll">
                        <v-list-item-content>
                          <v-list-item-title>Select All</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="selectNone">
                        <v-list-item-content>
                          <v-list-item-title>Select None</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                    <v-divider></v-divider>
                  </template>
                </v-select>
                <v-divider style="margin: 8px"></v-divider>
                <span class="headline">System Settings</span>
                <v-divider style="margin: 8px"></v-divider>
                <v-icon
                  :color="tableMobile == 0 ? 'grey' : 'primary'"
                  small
                  class="mr-2"
                  @click="tableMobile = tableMobile == 0 ? 600 : 0"
                >
                  display_settings
                </v-icon>
                <span>{{ "Mobile Display" }} </span>
              </v-card-text>

              <v-card-actions>
                <v-btn color="primary" @click="dialogFilter = false"
                  >Close</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-divider vertical style="margin: 0 8px"></v-divider>
          <v-dialog
            v-model="dialog"
            :retain-focus="false"
            max-width="700px"
            persistent
          >
            <template v-slot:activator="{ on, attrs }">
              <!-- <span>{{ " Add Athlete" }} </span> -->
              <v-icon color="primary" dark v-on="on" v-bind="attrs">
                group_add
              </v-icon>
            </template>
          </v-dialog>
        </template>
      </BaseToolbar>
    </div>

    <v-data-table
      tableStyle="min-width: 50rem"
      :headers="headers"
      :items="sortedGroupData"
      :search="search"
      :loading="loading"
      class="elevation-5"
      loading-text="Loading... Please wait"
      hide-default-footer
      :items-per-page="-1"
      :item-class="getItemClass"
      item-key="node.teamId"
      :expanded.sync="expanded"
      show-expand
    >
      <!-- Expandable row template -->

      <!-- <template v-slot:item.data-table-expand="{ expand, isExpanded }">
        <v-icon @click="expand(!isExpanded)">
          {{ isExpanded ? "fas fa-chevron-up" : "fas fa-chevron-down" }}
        </v-icon>
      </template> -->

      <!-- In GroupList.vue expanded row -->
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="pa-5">
          <div class="mb-4">
            <WorkoutSchedule
              :groupId="item.node.teamId"
              :eventId="selectedEvent"
              :competitiveFlag="item.node.competitiveFlag"
            />
          </div>
        </td> </template>
      <template #footer>
  <v-btn color="primary" class="no-print" @click="printPage">Print Table</v-btn>
  <v-btn
    color="primary"
    :disabled="isSendGroupEmail"
    @click="sendGroupEmail"
    :title="isSendGroupEmail ? 'Test' : ''"
    >{{
      isSendGroupEmail ? "Select Groups for Email" : "Send Group(s) Email"
    }}</v-btn
  >
</template>
      <template v-slot:body.append>
  <tr class="total-row">
    <td colspan="5" class="text-right"></td>
    <td class="text-center">
      <strong>{{ totalActiveAthletes }}</strong>
    </td>
    <td class="text-center">
      <strong>{{ totalMaxAthletes }}</strong>
    </td>
    <td class="text-center">
      <strong>{{ totalMaxAthletes - totalActiveAthletes }}</strong>
    </td>
    <td class="text-center">
      <strong>{{ totalLeads }}</strong>
    </td>
    <td class="text-center">
      <strong>{{ totalReconnectLeads }}</strong>
    </td>

    <td class="text-center">
      <strong>{{ totalMalevsFemale }}</strong>
    </td>
    <!-- <td colspan="4"></td> -->
    <!-- Fill the remaining cells -->
  </tr>
</template>
      <!-- Clickable Group Name -->
      <template v-slot:[`item.node.teamName`]="{ item }">
  <a
    href="#"
    @click.prevent="goToTeam($route.params.club, item.node.teamName)"
    class="team-link"
  >
    {{ item.node.teamName }}
  </a>
</template>

      <!-- Clickable Leads Value with multiple statuses -->
      <template v-slot:[`item.node.leadsCount`]="{ item }">
  <a
    href="#"
    @click.prevent="
      goToAthletes($route.params.club, item.node.teamName, 'LEADS')
    "
    class="leads-link"
  >
    {{ item.node.leadsCount }}
  </a>
</template>
      <template v-slot:[`item.node.reconnectLeadsCount`]="{ item }">
  <a
    href="#"
    @click.prevent="
      goToAthletes($route.params.club, item.node.teamName, 'RECONNECT_LEADS')
    "
    class="leads-link"
  >
    {{ item.node.reconnectLeadsCount }}
  </a>
</template>

      <!-- Scoped slot for the Team Description column -->
      <template v-slot:[`item.node.teamDescription`]="{ item }">
  <span>{{ truncateText(item.node.teamDescription) }}</span>
</template>
      <!-- Scoped slot for the Commitment Requirements column -->
      <template v-slot:[`item.node.commitmentRequirements`]="{ item }">
  <span>{{ truncateText(item.node.commitmentRequirements) }}</span>
</template>

      <!-- Scoped slot for Max Athletes column - use aggregated workout schedule data -->
      <template v-slot:[`item.node.maxAthletes`]="{ item }">
  <span>{{ getGroupMaxAthletes(item.node.teamId) }}</span>
</template>

      <template v-slot:[`item.availableSpots`]="{ item }">
  <span>{{ item.availableSpots >= 0 ? item.availableSpots : 0 }}</span>
</template>
      <!-- Render Male vs Female athletes count in the table -->
      <template v-slot:[`item.maleVsFemale`]="{ item }">
  <span>{{ item.maleVsFemale }}</span>
</template>
      <template v-slot:[`item.action`]="{ item }">
  <div class="action-container">
    <v-menu offset-y open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-small color="primary" dark v-bind="attrs" v-on="on">
          <v-icon small>more_vert</v-icon>
        </v-btn>
      </template>
      <!-- Menu content (will only be visible when the menu is active) -->
      <v-list>
        <!-- Edit Action -->
        <v-list-item @click="editItem(item.node)">
          <v-list-item-icon>
            <v-icon>edit</v-icon>
            <!-- Edit icon -->
          </v-list-item-icon>
          <v-list-item-title>Edit</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item @click="sendGroupEmail(item.node)">
                <v-list-item-icon>
                  <v-icon>email</v-icon>                  
                </v-list-item-icon>
                <v-list-item-title>Email </v-list-item-title>
              </v-list-item> -->
        <!-- Delete Action -->
        <v-list-item @click="deleteItem(item.node)">
          <v-list-item-icon>
            <v-icon>delete</v-icon>
            <!-- Delete icon -->
          </v-list-item-icon>
          <v-list-item-title>Delete</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-checkbox
      class="small-checkbox"
      :input-value="isSelected(item.node.teamId)"
      @change="toggleSelection(item.node.teamId)"
      hide-details
    ></v-checkbox>
  </div>
</template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <!-- Total Row Below the Table
    <v-row class="mt-4 justify-end">
      <v-col cols="12" sm="4" class="text-right total-row">
        <v-card outlined>
          <v-card-text>
            <strong>Total Active Athletes: {{ totalActiveAthletes }}</strong>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <!-- Total Max Athletes -->
    <!-- <v-row class="mt-2 justify-end">
      <v-col cols="12" sm="4" class="text-right">
        <v-card outlined>
          <v-card-text>
            <strong>Total Max Athletes: {{ totalMaxAthletes }}</strong>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row> -->
    <v-dialog
      v-model="dialog"
      :retain-focus="false"
      max-width="1200px"
      persistent
    >
      <!-- <template v-slot:activator="{ on }">
                <v-btn color="primary" dark v-on="on">New Item</v-btn>
              </template> -->
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.teamName"
                  label="Group Name"
                  :rules="nameRules"
                  :counter="50"
                  :hint="editedItem.teamId ? `🆔 ${editedItem.teamId}` : 'Team ID will be auto-generated after saving'"
                  persistent-hint
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.teamDescription"
                  label="Group Description"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                              <catValueDropDown
                :outlined="true"
                label="Sport type"
                catName="SPORT_TYPE"
                v-model.trim="editedItem.sportType"
              />
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-switch
                  v-model="editedItem.visibility"
                  label="Visibility"
                  inset
                ></v-switch>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.logo"
                  label="Logo"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.orderOnUi"
                  label="OrderOnUI"
                ></v-text-field>
              </v-flex>
              <!-- Swimmers per Group -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.maxAthletes"
                  label="Max Number of Athletes"
                ></v-text-field>
              </v-flex>
              <!-- Ratio -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.studentCoachRatio"
                  label="Student to Coach Ratio"
                ></v-text-field>
              </v-flex>
              <!-- Competitive Flag -->
              <v-flex xs12 sm6 md4>
                <v-switch
                  v-model="editedItem.competitiveFlag"
                  label="Competitive Flag Group"
                  inset
                ></v-switch>
              </v-flex>
              <!-- Fees: Monthly, Fundraising, Registration -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.registrationFee"
                  label="Registration Fee"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.monthlyFee"
                  label="Monthly Fee"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.fundrasingFee"
                  label="Volunteering Fee"
                ></v-text-field>
              </v-flex>

              <!-- Coach ID -->
              <v-flex xs12 sm6 md4>
                <v-text-field
                  type="number"
                  v-model="editedItem.coaches"
                  label="Coach"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.commitmentRequirements"
                  label="Commitment Requirements"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-textarea
                  v-model="paymentLinkJson"
                  label="Payment Link (JSON)"
                  rows="4"
                ></v-textarea>
              </v-flex>

              <v-flex xs12 sm6 md4>
                <v-textarea
                  v-model="formsToSignJson"
                  label="Forms To Sign (JSON)"
                  rows="4"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.year"
                      label="Year"
                      prepend-icon="event"
                      v-on="on"
                      readonly
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.year"
                    @input="menu = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">Cancel</v-btn>
          <v-btn :disabled="!isFormValid" color="secondary" text @click="save"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center pt-2">
      <v-pagination v-model="page" :length="pageCount"></v-pagination>
    </div>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import BaseToolbar from "../../base/BaseToolbar.vue";
import { getCatValues } from "../../../mixins/getCatValues.js";
import WorkoutSchedule from "./WorkoutSchedule.vue"; // Import child component
import { getWorkoutScheduleById } from "../../../_helpers/index";
import EventCatalogSelect from "../../shared/selectEventCatalog.vue";
import catValueDropDown from "../../shared/cat_val_dropdown.vue";

const ATHLETE_STATUS_GROUPS = {
  LEADS: ["applied", "approved", "deposit", "tryout"],
  RECONNECT_LEADS: ["waitlist", "reconnect"],
  ACTIVE: ["active"],
};

export default {
  components: {
    BaseToolbar,
    WorkoutSchedule,
    EventCatalogSelect, // Add this
    catValueDropDown
  },
  mixins: [getCatValues],
  data() {
    return {
      selectedEvent: [46, 49],
      tableMobile: 0,
      status_selected: ["active"],
      selectedTeams: [], // Array to store selected team IDs
      selectedTab: "", // Store the selected Group Name
      statuses: [], // Store the statuses from query parameters
      clubId: null, // Store the clubId from route params
      competitiveFilter: "all", // Default to 'all',
      expanded: [],
      filterOptions: [
        { value: "all", text: "Show All" },
        { value: "competitive", text: "Competitive Teams" },
        { value: "non-competitive", text: "Non-Competitive Teams" },
      ],
      page: 1,
      itemsPerPage: 10,
      pageCount: 0,
      isFormValid: true,
      //status: "active",
      search: "",
      searchVisible: false,
      totalAthletes: "",
      totalGroups: "",
      on: 1,
      currentDate: new Date().toISOString().substr(0, 10),
      dialog: false,
      menu: false,
      name: "Default",
      dialogFilter: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 50) || "Name must be less than 10 characters",
      ],
      requiredRule: [(v) => !!v || "Value is required"],
      headers: [
        {
          text: "Actions",
          value: "action",
          sortable: false,
          align: "left",
        },
        {
          text: "Group Name",
          align: "left",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.teamName",
        },
        {
          text: "Group Description",
          align: "center",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.teamDescription",
        },
        {
          text: "Commitment Requirements",
          align: "center",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.commitmentRequirements",
        },
        {
          text: "Number Athletes",
          value: "node.activeAthletes.length", // Updated to show only active athletes count
          sortable: false,
          align: "center",
        },
        {
          text: "Max Number of Athletes",
          align: "center",
          sortable: false, // Disable sorting for simplicity on total row
          value: "node.maxAthletes",
        },
        {
          text: "Available Spots",
          value: "availableSpots",
          align: "center",
          sortable: true,
        },
        {
          text: "Active Leads",
          value: "node.leadsCount",
          align: "center",
          sortable: false,
        },

        {
          text: "Reconnect Leads",
          value: "node.reconnectLeadsCount",
          align: "center",
          sortable: false,
        },
        {
          text: "Male/Female",
          value: "maleVsFemale",
          align: "center",
          sortable: false,
        },
        // {
        //   text: "Sport Type",
        //   value: "node.sportType",
        //   align: "center"
        // },
        // {
        //   text: "Order On UI",
        //   align: "center",
        //   sortable: true,
        //   value: "node.orderOnUi"
        // },
      ],
      editedIndex: -1,
      editedItem: {
        teamId: "",
        teamName: "",
        year: 0,
        toYear: 0,
        visibility: true,
        sportType: 0,
        orderOnUi: 100,
        logo: 0,
        competitiveFlag: false,
        monthlyFee: 0,
        fundrasingFee: 0,
        registrationFee: 0,
        coaches: null,
        maxAthletes: 0,
        studentCoachRatio: 0,
        teamDescription: null,
        commitmentRequirements: null,
        paymentLink: {},
        formsToSign: [],
      },
      defaultItem: {
        teamId: "",
        teamName: "",
        year: 0,
        toYear: 0,
        visibility: 1,
        sportType: 0,
        orderOnUi: 100,
        logo: 0,
        competitiveFlag: false,
        monthlyFee: 0,
        fundrasingFee: 0,
        registrationFee: 0,
        coaches: null,
        maxAthletes: 0,
        studentCoachRatio: 0,
        teamDescription: null,
        commitmentRequirements: null,
        paymentLink: {},
        formsToSign: [],
      },
    };
  },
  created() {
    this.allWorkoutSchedules();
    this.handleGetClubInfo();
    this.allClubPersonRel({ clubId: this.$route.params.club })
      .then(() => (this.loadingTable = false))
      .catch((error) => {
        this.loadingTable = false;
        //console.error(error);
      });
    // Read the 'tab' and 'status' query parameters
    this.selectedTab = this.$route.query.tab || "Unknown Group";
    this.statuses = Array.isArray(this.$route.query.status)
      ? this.$route.query.status
      : [this.$route.query.status]; // Ensure statuses is an array

    // Read the 'clubId' from route params
    this.clubId = this.$route.params.clubId;
  },
  computed: {
    ...mapGetters([
      "loading",
      "clubInfo",
      "categoryValue",
      "user",
      "workoutSchedules",
      "clubPersonRel", // Make sure this is included
    ]),

    statusOptions() {
      return [...this.catValueListArray("athlete_status")];
    },
    paymentLinkJson: {
      get() {
        try {
          const raw = this.editedItem.paymentLink;

          // If it's already an object, return as pretty-printed string
          if (typeof raw === "object") {
            return JSON.stringify(raw, null, 2);
          }

          // If it's a string, try parsing it once
          const parsed = JSON.parse(raw);
          return JSON.stringify(parsed, null, 2);
        } catch (e) {
          return this.editedItem.paymentLink || "";
        }
      },
      set(val) {
        try {
          const parsed = JSON.parse(val);
          this.editedItem.paymentLink = parsed; // set the parsed object
        } catch (e) {
          // fallback: set raw string if not valid JSON
          this.editedItem.paymentLink = val;
        }
      },
    },
    formsToSignJson: {
      get() {
        try {
          const raw = this.editedItem.formsToSign;

          if (Array.isArray(raw)) {
            return JSON.stringify(raw, null, 2);
          }

          const parsed = JSON.parse(raw);
          return JSON.stringify(parsed, null, 2);
        } catch (e) {
          return this.editedItem.formsToSign || "";
        }
      },
      set(val) {
        try {
          const parsed = JSON.parse(val);
          this.editedItem.formsToSign = parsed;
        } catch (e) {
          this.editedItem.formsToSign = val;
        }
      },
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Group" : "Edit Group";
    },
    isSendGroupEmail() {
      return this.selectedTeams.length === 0;
    },
    sortedGroupData() {
      // Sort by orderOnUi in ascending order and return sorted data
      return this.filteredGroupData
        .slice()
        .sort((a, b) => a.node.orderOnUi - b.node.orderOnUi);
    },
    groupData() {
      if (this.clubInfo.edges && this.clubInfo.edges.length > 0) {
        const clubIndex = this.clubInfo.edges.findIndex(
          (elem) => elem.node.clubId == this.$route.params.club.toString()
        );

        if (clubIndex !== -1) {
          return this.clubInfo.edges[clubIndex].node.team.edges.map((team) => {
            const teamAthletes = this.getAthletesForTeam(team.node.teamId);

            // ✅ FIXED: Use correct property paths
            const activeAthletes = teamAthletes.filter((athlete) => {
              const matchesStatus = this.status_selected.includes(
                athlete.status
              );
              const matchesEvent =
                this.selectedEvent.length > 0
                  ? this.selectedEvent.includes(athlete.event.eventId)
                  : true;
              return matchesStatus && matchesEvent;
            });

            // ✅ FIXED: Use athlete.person.gender
            const maleCount = activeAthletes.filter(
              (athlete) => athlete.person.gender === "male"
            ).length;
            const femaleCount = activeAthletes.filter(
              (athlete) => athlete.person.gender === "female"
            ).length;

            // Calculate leads and reconnect leads with correct structure
            const leadsCount = teamAthletes.filter((athlete) => {
              const matchesStatus = ATHLETE_STATUS_GROUPS.LEADS.includes(
                athlete.status
              );
              const matchesEvent =
                this.selectedEvent.length > 0
                  ? this.selectedEvent.includes(athlete.event.eventId)
                  : true;
              return matchesStatus && matchesEvent;
            }).length;

            const reconnectLeadsCount = teamAthletes.filter((athlete) => {
              const matchesStatus =
                ATHLETE_STATUS_GROUPS.RECONNECT_LEADS.includes(athlete.status);
              return matchesStatus;
            }).length;

            const maxAthletes = team.node.maxAthletes;
            const aggregatedMaxAthletes = this.getGroupMaxAthletes(team.node.teamId);

            return {
              ...team,
              node: {
                ...team.node,
                activeAthletes,
                leadsCount,
                reconnectLeadsCount,
                maxAthletes,
              },
              availableSpots: aggregatedMaxAthletes - activeAthletes.length,
              maleVsFemale: `${maleCount} / ${femaleCount}`,
            };
          });
        }

        return this.clubInfo.edges[0].node.team.edges;
      }
      return [];
    },

    filteredGroupData() {
      let filtered = this.groupData;

      // Filter by competitive flag only (event filtering is already done in groupData)
      if (this.competitiveFilter !== "all") {
        const isCompetitive = this.competitiveFilter === "competitive";
        filtered = filtered.filter((team) => {
          if (isCompetitive) {
            return team.node.competitiveFlag === 1;
          } else {
            return (
              team.node.competitiveFlag === 0 ||
              team.node.competitiveFlag === null
            );
          }
        });
      }

      return filtered;
    },
    getWorkoutScheduleById,
    totalActiveAthletes() {
      return this.filteredGroupData
        .filter(
          (team) => !team.node.teamName.includes("TRYOUT", "Inactive", "ALL")
        )
        .reduce((sum, team) => sum + team.node.activeAthletes.length, 0);
    },
    totalMaxAthletes() {
      // Aggregate maxAthletes from workoutSchedules instead of group level
      if (!this.workoutSchedules || !Array.isArray(this.workoutSchedules)) {
        return 0;
      }

      // Get all group IDs from filtered groups
      const groupIds = this.filteredGroupData.map(team => team.node.teamId);
      
      // Sum up maxAthletes from workoutSchedules for these groups
      const aggregatedFromSchedules = this.workoutSchedules
        .filter(schedule => 
          groupIds.includes(schedule.groupId) && 
          schedule.maxAthletes && 
          schedule.maxAthletes > 0
        )
        .reduce((sum, schedule) => sum + schedule.maxAthletes, 0);

      // If no workout schedules have maxAthletes, fall back to group-level maxAthletes
      if (aggregatedFromSchedules === 0) {
        return this.filteredGroupData.reduce(
          (sum, team) => sum + (team.node.maxAthletes || 0),
          0
        );
      }

      // For mixed scenarios, use the getGroupMaxAthletes method for each group
      return this.filteredGroupData.reduce(
        (sum, team) => sum + this.getGroupMaxAthletes(team.node.teamId),
        0
      );
    },
    totalLeads() {
      return this.filteredGroupData.reduce(
        (sum, team) => sum + team.node.leadsCount,
        0
      );
    },
    totalReconnectLeads() {
      return this.filteredGroupData.reduce(
        (sum, team) => sum + team.node.reconnectLeadsCount,
        0
      );
    },
    totalMalevsFemale() {
      let totalMale = 0;
      let totalFemale = 0;

      this.filteredGroupData
        .filter(
          (team) => !team.node.teamName.includes("TRYOUT", "Inactive", "ALL")
        )
        .forEach((team) => {
          const activeAthletes = team.node.activeAthletes;

          totalMale += activeAthletes.filter(
            (athlete) => athlete.person.gender === "male"
          ).length;

          totalFemale += activeAthletes.filter(
            (athlete) => athlete.person.gender === "female"
          ).length;
        });

      return `${totalMale}/${totalFemale}`;
    },
    clubInfoNew() {
      return this.clubInfo.edges.filter(
        (item) => item.node.clubId == this.$route.params.club
      );
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    ...mapActions(["allWorkoutSchedules", "allClubPersonRel"]),

    // Get aggregated maxAthletes from workoutSchedules for a specific group
    getGroupMaxAthletes(groupId) {
      if (!this.workoutSchedules || !Array.isArray(this.workoutSchedules)) {
        return 0;
      }

      const aggregatedMax = this.workoutSchedules
        .filter(schedule => 
          schedule.groupId === groupId && 
          schedule.maxAthletes && 
          schedule.maxAthletes > 0
        )
        .reduce((sum, schedule) => sum + schedule.maxAthletes, 0);

      // If no workout schedules have maxAthletes set, fall back to group-level maxAthletes
      if (aggregatedMax === 0) {
        // Access raw club data directly to avoid circular dependency
        if (this.clubInfo.edges && this.clubInfo.edges.length > 0) {
          const clubIndex = this.clubInfo.edges.findIndex(
            (elem) => elem.node.clubId == this.$route.params.club.toString()
          );
          
          if (clubIndex !== -1) {
            const team = this.clubInfo.edges[clubIndex].node.team.edges
              .find(team => team.node.teamId === groupId);
            return team ? team.node.maxAthletes || 0 : 0;
          }
        }
        return 0;
      }

      return aggregatedMax;
    },

    // Toggle the selection state for a team ID
    toggleSelection(teamId) {
      if (this.selectedTeams.includes(teamId)) {
        this.selectedTeams = this.selectedTeams.filter((id) => id !== teamId);
      } else {
        this.selectedTeams.push(teamId);
      }
    },
    // Check if a team is selected
    isSelected(teamId) {
      return this.selectedTeams.includes(teamId);
    },
    filterGroupData() {
      // Removed: console.log(`Filtering by: ${this.competitiveFilter}`);
    },
    // Opens the Athlete List page in a new tab with the desired statuses and Group Name
    // ✅ SIMPLIFIED: Just add tryout event ID for RECONNECT_LEADS
    goToAthletes(clubId, teamName, statusType = "LEADS") {
      const statuses = ATHLETE_STATUS_GROUPS[statusType] || ATHLETE_STATUS_GROUPS.LEADS;
      
      let eventsToPass = [...this.selectedEvent];
      if (statusType === "RECONNECT_LEADS") {
        eventsToPass = ["ALL"];
      }

      // Removed: console.log(`Navigating to athlete_list for team: ${teamName}...`);

      const routeData = this.$router.resolve({
        path: `/${clubId}/club/athlete_list`,
        query: {
          tab: "dataTable",
          subTab: teamName,
          status: statuses,
          events: eventsToPass,
        },
      });
      window.open(routeData.href, "_blank");
    },

    goToTeam(clubId, teamName) {
      // Removed: console.log(`Navigating to athlete_list for team: ${teamName}...`);
      
      const routeData = this.$router.resolve({
        path: `/${clubId}/club/athlete_list`,
        query: {
          tab: "dataTable",
          subTab: teamName,
          status: this.status_selected,
          events: this.selectedEvent,
        },
      });
      window.open(routeData.href, "_blank");
    },
        truncateText(text, length = 50) {
      if (!text) return "";
      return text.length > length ? text.substring(0, length) + "..." : text;
    },
    printPage() {
      // Accessing the window object directly
      window.print(); // This triggers the print dialog
    },
    getItemClass(item) {
      return item.node.teamName === "Total" ? "total-row" : "";
    },
    sendGroupEmail() {
      // ✅ CLEANED: Remove all debug logging
      const selectedTeamEmails = [];
      const selectedTeamNames = [];

      this.filteredGroupData.forEach((team) => {
        if (this.selectedTeams.includes(team.node.teamId)) {
          selectedTeamNames.push(team.node.teamName);
          const teamAthletes = this.getAthletesForTeam(team.node.teamId);
          
          const emails = teamAthletes
            .filter((athlete) => {
              const matchesStatus = this.status_selected.includes(athlete.status);
              const matchesEvent = this.selectedEvent.length > 0
                ? this.selectedEvent.includes(athlete.event.eventId)
                : true;
              const hasEmail = athlete.person.email && athlete.person.email.trim() !== "";
              
              return matchesStatus && matchesEvent && hasEmail;
            })
            .map((athlete) => athlete.person.email);
            
          selectedTeamEmails.push(...emails);
        }
      });

      if (!selectedTeamEmails.length) {
        alert("No active athletes with valid email addresses in the selected teams.");
        return;
      }

      const uniqueEmails = [...new Set(selectedTeamEmails)];
      const teamList = selectedTeamNames.join(", ");
      const clubName = this.clubInfoNew[0].node.clubName;
      
      const subject = encodeURIComponent(
        `Announcement for ${teamList} Teams from Club ${clubName}`
      );
      const body = encodeURIComponent(
        `Hello Groups,\n\n` +
          `If you got this email, you are part of ${clubName} communication for selected teams: ${teamList}.\n\n` +
          `We would like to inform you about upcoming events.\n\n` +
          `1. Training Schedule: Updated for next month\n` +
          `2. Fees: Please ensure payments are up-to-date\n` +
          `3. Tournament: Confirm your participation by Friday\n\n` +
          `Best Regards,\n` +
          `RocketSwim Management`
      );

      const mailtoLink = `mailto:?bcc=${uniqueEmails.join(";")}
&subject=${subject}&body=${body}`;

      window.location.href = mailtoLink;
    },
    sportTypeList: function () {
      return this.categoryValue.edges
        .filter((category) => category.node.category)
        .filter((category) => category.node.category.catName == "SPORT_TYPE");
    },
    handleGetClubInfo() {
      //reach out of Vuex store, fire action that gets athletes
      this.$store.dispatch("allAthlete", {
        clubId: this.$route.params.club,
      });
    },
    parseMaybeJSON(val) {
      if (typeof val === "string") {
        try {
          const cleaned = val.replace(/^"+|"+$/g, "").replace(/'/g, '"');
          return JSON.parse(cleaned);
        } catch (_) {}
      }
      return val;
    },
    GroupMutate() {
      // console.log("Team", this.editedItem);
      //console.log("Initiating GroupMutate..."); // Track when the function is triggered
      //console.log("Edited Item Data:", this.editedItem); // Log data being sent
      this.$store.dispatch("groupMerge", {
        teamId: this.editedItem.teamId,
        teamName: this.editedItem.teamName,
        year: this.editedItem.year
          ? this.editedItem.year.substring(0, 4)
          : null,
        toYear: this.editedItem.toYear,
        clubId: this.$route.params.club,
        visibility: this.editedItem.visibility,
        orderOnUi: this.editedItem.orderOnUi ? this.editedItem.orderOnUi : 100,
        sportType: this.editedItem.sportType,
        logo: this.editedItem.logo,
        maxAthletes: this.editedItem.maxAthletes,
        competitiveFlag: this.editedItem.competitiveFlag,
        studentCoachRatio: this.editedItem.studentCoachRatio,
        monthlyFee: this.editedItem.monthlyFee,
        registrationFee: this.editedItem.registrationFee,
        fundrasingFee: this.editedItem.fundrasingFee,
        coaches: this.editedItem.coaches,
        teamDescription: this.editedItem.teamDescription,
        commitmentRequirements: this.editedItem.commitmentRequirements,
        formsToSign: this.parseMaybeJSON(this.editedItem.formsToSign),
        paymentLink: this.parseMaybeJSON(this.editedItem.paymentLink),
        updateSource: "VueJS tst",
      });
    },
    GroupDelete() {
      this.$store.dispatch("groupDelete", {
        clubId: this.$route.params.club,
        teamId: this.editedItem.teamId,
      });
      this.editedItem = {};
    },
    editItem(item) {
      this.editedIndex = this.clubInfo.edges[0].node.team.edges.findIndex(
        (x) => x.node === item
      );
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.handleGetClubInfo.toString().indexOf(item);
      this.editedItem = Object.assign({}, item);
      confirm("Are you sure you want to delete this item?") &&
        // this.handleGetClubInfo.splice(index, 1);
        this.GroupDelete(index);
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      this.GroupMutate();
      this.close();
    },
    isAdmin() {
      return this.user && this.user.role == "Administrator";
    },

    // ✅ NEW: Get athletes for a specific team from clubPersonRel
    getAthletesForTeam(teamId) {
      if (!this.clubPersonRel) {
        // Removed: console.log("No clubPersonRel data available");
        return [];
      }

      // Removed: console.log(`Getting athletes for team ${teamId}...`);
      const athletes = this.clubPersonRel.filter(
        (athlete) => athlete.teamId === teamId
      );
      // Removed: console.log(`Found ${athletes.length} athletes...`);
      return athletes;
    },

    // Remove entire mounted hook since it only has console.log
    // mounted() {
    //   console.log("Filtered Group Data:", this.filteredGroupData);
    // },
  },
  mounted() {
    //console.log(this.user);
  },
};
</script>
<style scoped>
.total-row {
  font-weight: bold;
  background-color: #f0f0f0;
}

.team-link {
  color: #1976d2;
  text-decoration: underline;
  cursor: pointer;
}

.team-link:hover {
  color: #1565c0;
}

/* Flex container to align checkbox and icons inline */
.action-container {
  display: flex;
  align-items: center;
}

/* Make checkbox smaller */
.small-checkbox {
  transform: scale(0.65);
  /* Scale down the checkbox */
  margin-top: 0;
  /* Add a small margin to align with icons */
}
</style>
